/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Adjust and copy-paste this script into a JS-console
 * and run `generateColTypes()`
 */
/* tslint:disable */
var createArrayOfLength_1 = require("./util/createArrayOfLength");
exports.generateColumnProps = function () {
    var columnSizes = ["xs", "sm", "md", "lg"];
    var gutterTypes = ["", "Wide", "Tight"];
    var columnCycles = ["1", "2", "3", "4", "5", "6", "7", "8"];
    var result = columnSizes.reduce(function (soFar, size) {
        soFar.push(size);
        return soFar;
    }, []);
    return columnSizes.reduce(function (soFar, size) { return soFar.concat(gutterTypes.reduce(function (gutters, gutterSize) { return gutters.concat(columnCycles.reduce(function (columns, column) { return columns.concat(createArrayOfLength_1.createArrayOfLength(parseInt(column, 10)).reduce(function (repeated, cycle, index) { return repeated.concat([
        ["" + size + gutterSize + (index + 1) + "of" + column]
    ]); }, [])); }, [])); }, [])); }, ["centered"]);
};
exports.generateColTypes = function () {
    var strings = [
        "/* Generated with GridTypesGenerator.js */",
        "export interface ColProps {",
        exports.generateColumnProps().map(function (property) { return "  " + property + "?: boolean;"; }),
        "}"
    ];
    return strings.join("\n");
};